import {add} from '@elements/scroll-animations';
import {findAll, closest, find, on, findAllIn} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";
import {onEnterViewPort} from '@elements/viewport-utils';
import * as formValidation from '@elements/form-validation';

let selectors = {
    base: '.js-required-if-checked',
    input: '.js-required-if-checked__input',
    target: '.js-required-if-checked__target',
    dataset: 'required-if-checked-target',
    wrapper: '.js-required-if-checked__input-wrapper'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let inputs = findAllIn(selectors.input, baseElement);
        let checkedRadio = inputs.filter(input => input.checked)[0];
        let targets = findAllIn(selectors.target, baseElement);

        if(checkedRadio) {
            let checkedTargets = findAll(checkedRadio.getAttribute(`data-${selectors.dataset}`));
            handleRequiredInput(checkedTargets);
        }

        inputs.map(input => {
            on('change', function() {
                let wrapper = closest(selectors.wrapper, input);
                let checkedTargets = findAllIn(selectors.target, wrapper);
                handleRequiredInput(checkedTargets, input);
            }, input)
        })

        function handleRequiredInput(checkedTargets, input = false) {
            let form;
            if(input) {
                form = closest('.js-form-validation', input);
            } else if(checkedTargets.length > 0) {
                form = closest('.js-form-validation', checkedTargets[0]);
            }

            if(form) {
                formValidation.getApi(form).then((formApi) => {
                    let formInstance = formApi.getFormInstance();
                    let fields = formInstance?.getFields();
                    targets.map(target => {
                        target.required = false;
                            let field =  fields[target.name];
                            if(field) {
                                formInstance.revalidateField(target.name);
                                formInstance.removeField(target.name);
                            }
                    })
                    if(checkedTargets) {
                        checkedTargets.map(checkedTarget => {
                            checkedTarget.required = true;
                            let field =  fields[checkedTarget.name];
                            if(field) {
                                formInstance.removeField(checkedTarget.name);
                            } else {
                                formInstance.addField(checkedTarget.name, {});
                            }

                        });
                    }
                });
            }

        }
    });
}